import { SidebarItem } from 'src/UI/page-nav/sidebar/types';
import { NonFinancialDataTabs } from '../types';

export function buildIndividualNavLinks(clientId: string): SidebarItem[] {
  const href = (slug: string) => `/client/${clientId}/non-financial-data/${slug}`;

  return [
    { label: 'Individual details', href: href(NonFinancialDataTabs.PersonalDetails) },
    { label: 'Dependants', href: href(NonFinancialDataTabs.Dependants) },
    {
      label: 'Health & vulnerabilities',
      href: href(NonFinancialDataTabs.HealthAndVulnerabilities),
    },
    { label: 'Employment', href: href(NonFinancialDataTabs.Employment) },
    { label: 'Objectives', href: href(NonFinancialDataTabs.Objectives) },
    { label: 'Estate planning', href: href(NonFinancialDataTabs.EstatePlanning) },
    {
      label: 'Risk & investment preferences',
      href: href(NonFinancialDataTabs.RiskAndInvestmentPreferences),
    },
    {
      label: 'Tax & advice moments',
      href: href(NonFinancialDataTabs.TaxAndAdviceMoments),
    },
    {
      label: 'Key contacts',
      href: href(NonFinancialDataTabs.AdvisorsProfessionalConnections),
    },
    { label: 'Saved memories', href: href(NonFinancialDataTabs.SavedMemories) },
  ];
}
